import React from 'react';
import { IOnClick } from '../FilterContainer';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { ISelectedFilterItem } from '../MiniFilterList';
import { getFilterItemName, getFilterTitle } from '../../utils/helpers';
import { ReactComponent as Close } from '../../assets/images/close.svg';

export default function MiniFilterItem(props: ISelectedFilterItem & IOnClick) {
  const { text, title, name, value, onClickFilter } = props;
  const styles = useStyles();

  const clickOptionItem = () => {
    const data = {
      [name]: value,
    };
    onClickFilter && onClickFilter(data);
  };

  return (
    <div className={styles.miniFilterContainer}>
      <span className={styles.title}>{`${getFilterTitle(title)}:`}</span>
      <span className={styles.text}>{getFilterItemName(text, name)}</span>
      <div className={styles.circle} onClick={clickOptionItem}>
        <Close className={styles.closeIcon} />
      </div>
    </div>
  );
}

const useStyles = makeStyles<Theme>((theme) => ({
  miniFilterContainer: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 10,
    marginBottom: 7,
    padding: '12px 18px',
    backgroundColor: '#FFF2E6',
    borderRadius: 5,
    cursor: 'default',
  },
  title: {
    color: '#686868',
  },
  text: {
    color: '#603004',
    marginLeft: 5,
    marginRight: 15,
  },
  circle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 15,
    height: 15,
    borderRadius: 10,
    backgroundColor: '#E8B382',
    cursor: 'pointer',
  },
  closeIcon: {
    width: 7,
    height: 7,
  },
}));
